<template>
	<div
		class="g-block-title-sidebar-en g-block-title-padding"
		:class="{
			'g-block-title-sidebar-en--edit': editable,
			'is-active': editable && active,
			'g-block-title-sidebar-en--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-sidebar-en__row">
			<div class="g-block-title-sidebar-en__bar" :style="{ background: themeColor }"></div>
			<div class="g-block-title-sidebar-en__content">
				<div class="g-block-title-sidebar-en__part g-block-title-sidebar-en__part--primary" :style="{ color: themeColor }">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-sidebar-en__text g-block-title-sidebar-en__text--primary"
						fit-content
						:model-value="data.primaryText"
						placeholder="中文标题"
						@update:model-value="onPrimaryUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-sidebar-en__text g-block-title-sidebar-en__text--primary"
						v-html="data.primaryText || ''"
					></div>
				</div>
				<div class="g-block-title-sidebar-en__part g-block-title-sidebar-en__part--secondary" :style="{ color: lightColor }">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-sidebar-en__text g-block-title-sidebar-en__text--secondary"
						fit-content
						:model-value="data.secondaryText"
						placeholder="副标题"
						@update:model-value="onSecondaryUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-sidebar-en__text g-block-title-sidebar-en__text--secondary"
						v-html="data.secondaryText || ''"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleSidebarEn',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
	};
</script>

<style scoped lang="less">
	@bar-width: 4px;

	.g-block-title-sidebar-en {
		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-sidebar-en__row {
		display: flex;
		align-items: stretch;
		gap: 10px;
	}

	.g-block-title-sidebar-en__bar {
		width: @bar-width;
		flex-shrink: 0;
		border-radius: 2px;
	}

	.g-block-title-sidebar-en__content {
		display: flex;
		flex-direction: column;
		gap: 4px;
		min-width: 0;
	}

	.g-block-title-sidebar-en__part {
		min-width: 0;
	}

	.g-block-title-sidebar-en__text {
		display: inline-flex;
		align-items: baseline;
		line-height: 1.3;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;

		&--primary {
			font-size: 18px;
			font-weight: 700;
		}

		&--secondary {
			font-size: 12px;
			font-weight: 400;
			text-transform: uppercase;
			letter-spacing: 0.02em;
		}

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			align-items: baseline;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.3;
			min-height: unset;
			height: auto;
			padding: 0;
			color: inherit;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			line-height: inherit;
			margin: 0;
			padding: 0;
			vertical-align: baseline;
			color: inherit;
		}
	}

	.g-block-title-sidebar-en--h5 {
		.g-block-title-sidebar-en__row {
			gap: 0.2rem;
		}

		.g-block-title-sidebar-en__bar {
			width: 0.08rem;
		}

		.g-block-title-sidebar-en__content {
			gap: 0.08rem;
		}

		.g-block-title-sidebar-en__text--primary {
			font-size: 0.36rem;
		}

		.g-block-title-sidebar-en__text--secondary {
			font-size: 0.24rem;
		}
	}
</style>
